module.exports = __webpack_public_path__ + "img/3.35893e43.png";